<template>
  <div>
    <b-alert
      show
      variant="light"
      class="margin-bottom font14px icon-dark-custom"
    >
      <h6>ตรวจสอบสิทธิการรักษาของผู้ป่วย (สปสช.)</h6>
      <div>
        <b-table
          striped
          hover
          small
          :items="TmpDataNHSO"
          :fields="TmpfieldsNHSO"
          class="font14px"
          head-variant="dark"
          bordered
          responsive
        >
        </b-table>
      </div>
    </b-alert>
    <div class="d-block text-center">
      <b-button
        variant="info"
        size="sm"
        class="d-print-none"
        v-print="'#modal-nhso-rights-data'"
      >
        Print
      </b-button>
      &nbsp;
      <b-button
        size="sm"
        class="d-print-none"
        @click="$bvModal.hide('modal-nhso-rights-data')"
        >Close</b-button
      >
    </div>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import feather from "vue-icon";
import store from "@/store/store";
import thaiDatetime from "@/functions/thaiDatetime";
import pjFunctions from "@/functions/pjFunctions";
import DocumentScan from "@/models/patientEMRs/DocumentScan";

Vue.use(feather, "v-icon");

@Component({
  data() {
    return {
      thaiDatetimeFc: null,
      pjFunctionsFc: null,
      TmpDataNHSO: [],
      TmpfieldsNHSO: []
    };
  },
  props: ["MyCid"],
  component: {
    thaiDatetime,
    pjFunctions
  },
  created() {
    this.thaiDatetimeFc = thaiDatetime.methods;
    this.pjFunctionsFc = pjFunctions.methods;
    this.setNHSO(this.MyCid);
  },
  watch: {
    MyCid: function() {
      this.setNHSO(this.MyCid);
    }
  },
  computed: {},
  methods: {
    setNHSO(cid) {
      let ScrObj = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "nhso-webservice", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          cid: cid
        })
        .then(function(response) {
          ScrObj.output = response.data;
          if (ScrObj.output.status === true) {
            ScrObj.TmpDataNHSO = [];

            ScrObj.TmpDataNHSO.push({
              list: "บัตรประชาชน",
              listDetail: ScrObj.output.result.cid
            });

            if (ScrObj.output.result.nhso_data) {
              ScrObj.TmpDataNHSO.push({
                list: "ชื่อ-สกุล",
                listDetail:
                  ScrObj.output.result.nhso_data.title_name +
                  ScrObj.output.result.nhso_data.fname +
                  " " +
                  ScrObj.output.result.nhso_data.lname
              });
              ScrObj.TmpDataNHSO.push({
                list: "วันเกิด",
                listDetail: ScrObj.thaiDatetimeFc.ThaiDate(
                  ScrObj.thaiDatetimeFc.ThiaDateToDate(
                    ScrObj.output.result.nhso_data.birthdate
                  )
                )
              });
              if (ScrObj.output.result.nhso_data.purchaseprovince) {
                ScrObj.TmpDataNHSO.push({
                  list: "จังหวัดที่ลงทะเบียนรักษา",
                  listDetail:
                    "(" +
                    ScrObj.output.result.nhso_data.purchaseprovince +
                    ")" +
                    " " +
                    ScrObj.output.result.nhso_data.purchaseprovince_name
                });
              }
              if (ScrObj.output.result.nhso_data.maininscl) {
                ScrObj.TmpDataNHSO.push({
                  list: "สิทธิหลักในการรับบริการ",
                  listDetail:
                    "(" +
                    ScrObj.output.result.nhso_data.maininscl +
                    ")" +
                    " " +
                    ScrObj.output.result.nhso_data.maininscl_name
                });
              }
              if (ScrObj.output.result.nhso_data.subinscl) {
                ScrObj.TmpDataNHSO.push({
                  list: "ประเภทสิทธิย่อย",
                  listDetail:
                    "(" +
                    ScrObj.output.result.nhso_data.subinscl +
                    ")" +
                    " " +
                    ScrObj.output.result.nhso_data.subinscl_name
                });
              }
              if (ScrObj.output.result.nhso_data.cardid) {
                ScrObj.TmpDataNHSO.push({
                  list: "รหัสบัตรประกันสุขภาพ",
                  listDetail: ScrObj.output.result.nhso_data.cardid
                });
              }
              if (ScrObj.output.result.nhso_data.startdate) {
                ScrObj.TmpDataNHSO.push({
                  list: "วันเริ่มใช้สิทธิ",
                  listDetail: ScrObj.thaiDatetimeFc.ThaiDate(
                    ScrObj.thaiDatetimeFc.ThiaDateToDate(
                      ScrObj.output.result.nhso_data.startdate
                    )
                  )
                });
              }
              if (ScrObj.output.result.nhso_data.expdate) {
                ScrObj.TmpDataNHSO.push({
                  list: "วันหมดสิทธิ",
                  listDetail: ScrObj.thaiDatetimeFc.ThaiDate(
                    ScrObj.thaiDatetimeFc.ThiaDateToDate(
                      ScrObj.output.result.nhso_data.expdate
                    )
                  )
                });
              }
              if (ScrObj.output.result.nhso_data.hsub) {
                ScrObj.TmpDataNHSO.push({
                  list: "หน่วยบริการปฐมภูมิ",
                  listDetail:
                    "(" +
                    ScrObj.output.result.nhso_data.hsub +
                    ")" +
                    " " +
                    ScrObj.output.result.nhso_data.hsub_name
                });
              }
              if (ScrObj.output.result.nhso_data.hmain) {
                ScrObj.TmpDataNHSO.push({
                  list: "หน่วยบริการที่รับการส่งต่อ",
                  listDetail:
                    "(" +
                    ScrObj.output.result.nhso_data.hmain +
                    ")" +
                    " " +
                    ScrObj.output.result.nhso_data.hmain_name
                });
              }
              if (ScrObj.output.result.nhso_data.paid_model) {
                ScrObj.TmpDataNHSO.push({
                  list: "Model",
                  listDetail: ScrObj.output.result.nhso_data.paid_model
                });
              }
              if (ScrObj.output.result.nhso_data.hmainOp) {
                ScrObj.TmpDataNHSO.push({
                  list: "หน่วยบริการประจำ",
                  listDetail:
                    "(" +
                    ScrObj.output.result.nhso_data.hmainOp +
                    ")" +
                    " " +
                    ScrObj.output.result.nhso_data.hmainOpName
                });
              }
              if (ScrObj.output.result.nhso_data.status) {
                ScrObj.TmpDataNHSO.push({
                  list: "สถานะ",
                  listDetail:
                    "(" +
                    ScrObj.output.result.nhso_data.status +
                    ")" +
                    " " +
                    ScrObj.pjFunctionsFc.NulltoStr(
                      ScrObj.output.result.nhso_data.status_desc
                    )
                });
              }
            }

            ScrObj.TmpfieldsNHSO = [
              { label: "รายการ", key: "list", isRowHeader: true },
              { label: "รายละเอียด", key: "listDetail" }
            ];
          } else {
            console.log("nhso-webservice : " + ScrObj.output.ErrorMessage);
          }
        })
        .catch(function(error) {
          ScrObj.output = error;
          console.log("nhso-webservice : " + ScrObj.output);
        })
        .finally(function() {});
    }
  }
})
export default class EmrCheckNHSO extends Vue {}
</script>

<style lang="scss">
.alert {
  margin-bottom: 0px !important;
}

.icon-css {
  margin-right: 4px;
  float: left;
}
</style>

